import useSWR from 'swr';
import { useAuthToken } from '@/contexts/auth/useAuthToken';
import { ApiError } from '../ApiError';
import { HTTP_STATUS_CODE } from '../constants';
import {
  SERVICE_ENDPOINT,
  fetchFromMTService,
} from '../fetcher/monitoringToolService';
import { FixtureSportDefinition } from '../types';

export const useSupportedSportDefinitions = () => {
  const token = useAuthToken();
  const { data, error } = useSWR<FixtureSportDefinition[], ApiError>(
    token
      ? {
          token,
          endpoint:
            SERVICE_ENDPOINT.Configurations().SupportedSportsDefinitions.GET,
        }
      : null,
    fetchFromMTService,
    {
      onErrorRetry: (e, _, config, revalidate, { retryCount }) => {
        if (
          e.status === HTTP_STATUS_CODE.NOT_FOUND ||
          e.status === HTTP_STATUS_CODE.UNAUTHORIZED
        )
          return;
        setTimeout(() => revalidate({ retryCount }), config.errorRetryInterval);
      },
      revalidateOnFocus: false,
    },
  );

  return {
    error: error,
    isLoading: !data && !error,
    sportDefinitions: data,
  };
};
